// FIXME: 現在2ステップが前提のコンポーネントになってるので、Nステップに対応できるようにすること。
import { type FC, type ReactNode } from "react";
import * as styles from "./styles.css";

type StepChartProps = {
  currentStep: 1 | 2;
  step1Url?: string;
  step2Url?: string;
  step1Name?: string;
  step2Name?: string;
  site: "biyo" | "kaigo";
};

type StepItemProps = {
  url?: string;
  isCurrent: boolean;
  children: ReactNode;
  site: StepChartProps["site"];
};

const StepItem: FC<StepItemProps> = ({ url, isCurrent, children, site }) => {
  if (isCurrent) {
    return (
      <li className={styles.step}>
        <span className={styles.stepLink.active[site]}>{children}</span>
      </li>
    );
  }
  if (url) {
    return (
      <li className={styles.step}>
        <a href={url} className={styles.stepLink.inactive}>
          {children}
        </a>
      </li>
    );
  }
  return (
    <li className={styles.step}>
      <span className={styles.stepLink.inactive}>{children}</span>
    </li>
  );
};

export const StepChart: FC<StepChartProps> = ({
  currentStep,
  step1Url,
  step2Url,
  step1Name = "基本情報",
  step2Name = "詳細情報",
  site,
}) => {
  const steps = [
    { url: step1Url, isCurrent: currentStep === 1, children: "STEP1", name: step1Name },
    { url: step2Url, isCurrent: currentStep === 2, children: "STEP2", name: step2Name },
  ];

  return (
    <ul className={styles.stepChart}>
      {steps.map((step) => (
        <StepItem key={step.name} url={step.url} isCurrent={step.isCurrent} site={site}>
          {step.children}
          <span className={styles.stepName}>{step.name}</span>
        </StepItem>
      ))}
    </ul>
  );
};
